import React, {useEffect, useLayoutEffect, useState} from "react";
import axios from "axios";
import logo from "../../Assets/Images/logo.png";
import "./Navbar.scss";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import _axios from "../../httpService";
import Advertisement from "./Advertisement";
import advertisement from "./Advertisement";

export default function Navbar({setIsAuth}) {
  // const [theme, setTheme] = useState(
  //   localStorage.getItem("theme") === null
  //     ? "light"
  //     : localStorage.getItem("theme")
  // );

  // function changeThemeOnChangeHandler(e) {
  //   e.target.checked ? setTheme("dark") : setTheme("light");
  // }
  const navigateTo = useNavigate();

  function logOutHandler() {

    let HOST = window.location.hostname === "localhost" ? "http://localhost/Git/Delsa/Frm" : "/Frm"
    const logOutRequest = axios({
      method: "post",
      url: `${HOST}/check_user/`,
      params: {logout: "logout"},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {

      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
      setIsAuth(false);
    }).catch((error) => {
      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
      setIsAuth(false);
      navigateTo("/Login");
    });

    toast.promise(logOutRequest, {
      pending: "در حال خروج از حساب",
      success: "خروج با موفقیت ثبت شد",
      error: "ثبت خروج با مشکل مواجه شد",
    });

    console.log("logOutRequest");
  }

  // useEffect(() => {
  //   localStorage.setItem("theme", theme);
  //   document.documentElement.dataset.theme = theme;
  // }, [theme]);

  // ad Settings
  // const [hasActiveAd, setHasActiveAd] = useState(false);
  const [config, setConfig] = useState([]);


  useEffect(() => {
    // sample Request
    // _axios.get(`${localStorage.getItem("apiUrl")}/test/`).then(response => {
    _axios.get(`https://jsonplaceholder.typicode.com/todos/1`).then(response => {
      setConfig( [
        {
        tagName: 'a',
        text: 'google',
        id: '',
        className: '',
        src: 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png',
        alt: 'GOOGLE',
        title: 'GOOGLE',
        href:'https://google.com',
        width: '',
        height:'',
        styles: {color:'blue', fontSize:'15px', border:'1px solid #000'},
        child:[
          {
            tagName: 'img',
            className: 'img-responsive',
            src: 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png',
            title: '',
            styles: {'color':'red', 'border':'1px solid #ff0000'}
          },

        ]
      }]);
    });
  },[]);

  return (
    <nav className="navbar">
      <div className="logo-container">
        <img src={logo} alt="logo"/>
      </div>
      <div className={"navBar__advertisement"} >
        {/*{config.length>0 && <Advertisement data={config}  />}*/}
      </div>
      {/* <!-- Links --> */}
      <ul className="navbar-nav">
        {/* <li className="nav-item">
         
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="customSwitches"
              onChange={(e) => {
                changeThemeOnChangeHandler(e);
              }}
              checked={theme === "dark" ? true : false}
            />
           
            <i className="fas fa-moon"></i>
           
          </div>
        </li> */}
        <li className="nav-item">
          <div className="nav-link" onClick={logOutHandler}>
            <i className="fas fa-power-off"></i>
          </div>
        </li>
      </ul>
    </nav>
  );
}
